<div class="raw-content-page-layout">
  <div class="logo-wrapper">
    <img [src]="BRAND.logo.maintenance" alt="logo" class="brand-logo" height="150"/>
  </div>

  <!-- Under maintenance -->
  <oth-hero [contents]="appHeroContents"
            [heroClass]="'no-padding'"></oth-hero>
  <oth-information-button (click)="router.navigate([URLS.root])" [informationType]="INFORMATION_TYPES.warning"
                          i18n-text="@@maintenance.home.button" text="HOME"></oth-information-button>
</div>
